import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import axios from "axios/index";
import {  isBrowser, isMobile} from "react-device-detect";

const opt = {
    0:{
        items:2
    },
    600:{
        items:3
    },
    1000:{
        items:6
    }
}

const opt2 = {
    0:{
        items:2
    },
    600:{
        items:2
    },
    1000:{
        items:2
    }
}




class Categories extends Component{
    constructor(props){
        super(props);
        this.state = {
            categories:[],
        }

        axios.get(`https://mportalsystem2.btect.sk/api/getcategories`)
            .then(res => {
                const data = res.data[0];
                this.setState({ categories: data });

            });


    }


    render(){

        return(
            <div className="categories">

                <div className="container">
                    <div className="row">
                        <Owl setSearchDefs={this.props.setSearchDefs} categories={this.state.categories}/>
                    </div>
                </div>

            </div>
        );
    }
}

class Owl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories:[],
        }
        axios.get(`https://mportalsystem2.btect.sk/api/getcategories`)
            .then(res => {
                const data = res.data[0];
                this.setState({ categories: data });

            });

        console.log(this.state.categories);
    }

    setit(id){
        var array = new Array();
        array.push(id);
        array.push(1);

        this.props.setSearchDefs(array);
    }

    render() {
        if(isMobile) {
            return (
                <div className="container">
                    <div className="row">
                    {

                        this.props.categories.map(data =>

                            <div className="col-4">
                                <a onClick={() => this.setit(data.id)}>
                                    <div className="wrap_icon">
                                        <div className="cat_icon">


                                            <img src={data.image}/>
                                        </div>
                                        <p>{data.title}</p>
                                    </div>
                                </a>
                            </div>
                        )
                    }
                    </div>
                </div>

            );
        }
        else{
            return (
                <OwlCarousel
                    className="owl-theme owl-cat"
                    loop
                    margin={10}
                    nav={true}
                    dots={false}
                    items={6}
                    responsive={
                        opt
                    }>

                    {
                        this.props.categories.map(data =>

                            <div className="item">
                                <a onClick={() => this.setit(data.id)}>
                                    <div className="wrap_icon">
                                        <div className="cat_icon">


                                            <img src={data.image}/>
                                        </div>
                                        <p>{data.title}</p>
                                    </div>
                                </a>
                            </div>
                        )
                    }


                </OwlCarousel>
            );
        }
    }
}






export default Categories;